module.exports = __webpack_public_path__ + "img/66.3bb872cf.jpg";